import { render, staticRenderFns } from "./bankAffTab.vue?vue&type=template&id=1817e053&lang=pug"
import script from "./bankAffTab.vue?vue&type=script&lang=js"
export * from "./bankAffTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports